import { Controller } from "@hotwired/stimulus"
export default class extends Controller {

  static targets = [
    "wrapper",
    "menuList",
    "menuButton"
  ]

  toggleMenu(event) {

    const status = this.wrapperTarget.getAttribute('data-menu');
    this.wrapperTarget.setAttribute('data-menu', status === 'closed' ? 'open' : 'closed');

    this.menuListTarget.classList.toggle('hidden');
    this.menuButtonTarget.querySelectorAll('svg').forEach(function(item, i){
      item.classList.toggle('hidden');
    });

  }

  openModal(event) {

    // initiated from click
    if (event.currentTarget) {

      window.history.pushState({}, '', event.currentTarget.getAttribute('href'));

      event.preventDefault();
      event.stopImmediatePropagation();

      var modal = event.currentTarget.getAttribute('data-modal');

    // initiated from hash url
    } else {

      var modal = event.querySelector('a').getAttribute('data-modal');

    }

    document.querySelector('html').classList.add('has-modal');
    document.querySelector('div[data-modal=' + modal + ']').classList.remove('hidden');
    document.querySelector('div[data-modal=' + modal + ']').classList.add('open');

    if (modal === 'modal--book') {
      this.loadCalendly();
    }

  }

  // widget.js (and the Stripe it pulls in) used to sit in the modal markup
  // unconditionally, so it loaded on every page view whether or not anyone
  // opened the booking modal. Loading it here, on first open only, keeps the
  // same url/parentElement/resize options Calendly was given before.
  loadCalendly() {

    if (window.calendlyWidgetLoaded) return;
    window.calendlyWidgetLoaded = true;

    var loading = document.getElementById('calendly-loading');
    var embed = document.getElementById('calendly-embed');

    var script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';

    script.onload = function () {
      window.Calendly.initInlineWidget({
        url: 'https://calendly.com/passflow/project-discussion/?hide_gdpr_banner=1',
        parentElement: embed,
        resize: true
      });
      if (loading) loading.classList.add('hidden');
      if (embed) embed.classList.remove('hidden');
    };

    script.onerror = function () {
      window.calendlyWidgetLoaded = false;
      if (loading) loading.textContent = 'Could not load the booking widget. Please try again.';
    };

    document.body.appendChild(script);

  }

  closeModal(event) {

    window.history.pushState({}, '', window.location.pathname);

    event.preventDefault();
    event.stopImmediatePropagation();

    document.querySelector('html').classList.remove('has-modal');
    document.querySelector('div[data-modal].open').classList.add('hidden');
    document.querySelector('div[data-modal].open').classList.remove('open');

  }

}